import { useTranslation } from 'next-i18next/pages';

import { monthlyHours, hourlySalary } from '@pflegia/util/functions/salary';
import { isDefined } from '@pflegia/util/functions/type-guards';

export const useParseSalary = (
  salary: {
    low?: number | null;
    high?: number | null;
  },
  isLeasing?: boolean,
  workingHours?: number | null,
): string | null => {
  const { low, high } = salary;
  const { t } = useTranslation('job', { keyPrefix: 'badges' });
  if (isLeasing && workingHours) {
    const hours = monthlyHours(workingHours);
    if (isDefined(low) && isDefined(high) && t) return `${hourlySalary(low, hours)}€ - ${hourlySalary(high, hours)}€ ${t('perHour')}`;
    if (isDefined(low) && t) return `${hourlySalary(low, hours)}€ ${t('perHour')}`;
    if (isDefined(high) && t) return `${hourlySalary(high, hours)}€ ${t('perHour')}`;
  }
  if (isDefined(low) && isDefined(high)) return `${low}€ - ${high}€`;
  if (isDefined(low)) return `${low}€`;
  if (isDefined(high)) return `${high}€`;
  return null;
};
